export default "__VITE_ASSET__B7ncgGI$__"